
<app-book
  *ngIf="loaderParamsToBookLoaderParams(service.params) as params"
  [shown]="service.shown"
  [title]="params.data.title || ''"
  [loading]="service.loading"
  (buttonClick)="service.confirm()"
></app-book>

<app-default
  *ngIf="loaderParamsToDefaultLoaderParams(service.params)"
  [shown]="service.shown"
></app-default>
